import { useMutation } from '@hooks/reactQuery';

import { acceptAssetByUnit } from '@api/assetsRent';

import { IApprovalActionAssetByUnitDTO } from '@interfaces/rent/dto/assetRentDTO';

import { APPROVAL_UNIT_INFO } from '@constants/queryKeys';

interface IUseMutateAcceptAssetByUnitProps {
	assetId: string;
	isAO: boolean;
	onSuccessCallbacks: Array<() => void>;
}

type TUseMutateAcceptAssetByUnitReturn = (data: IApprovalActionAssetByUnitDTO) => void;

export const useMutateAcceptAssetByUnit = ({
	assetId,
	isAO,
	onSuccessCallbacks,
}: IUseMutateAcceptAssetByUnitProps) => {
	const { mutate: acceptAssetByApprovalUnit } = useMutation({
		mutationKey: [APPROVAL_UNIT_INFO, assetId, isAO],
		mutationFn: ({
			approvalUnitId,
			comment,
			itemId,
		}: IApprovalActionAssetByUnitDTO) => {
			return acceptAssetByUnit({
				approvalUnitId,
				comment,
				itemId,
			});
		},
		onSuccess: () => {
			if (onSuccessCallbacks.length) onSuccessCallbacks.forEach((callback) => callback());
		},
	});

	return {
		acceptAssetByApprovalUnit: acceptAssetByApprovalUnit as unknown as TUseMutateAcceptAssetByUnitReturn,
	};
};
